import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/cloud-app/future_cloud.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={7} xxl={7}>
            <h2>
              Future-Proof Your IT Operations with{" "}
              <span> Cloud Application Development Company</span>
            </h2>
            <p>
              Ready for the cloud? Share your requirements and the vision behind
              them, and our team of experts will be right at your service with
              quickly possible solutions.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Consult Cloud Solutions
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
